<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1"><span class="CharOverride-1">The Franklin Avenue Rookery for Wayward Babies </span></p>
<p class="ORIM-Book-Subtitle--Front-Matter-"><span class="CharOverride-1">And Other Stories</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-1">Laura Newman</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><img src="ORIM/del.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FranklinAve-1.vue?23433fb9